import {useMemo} from "react";

export default function useFormErrorPicker<T extends Record<string, string>, K extends keyof T>(
  errors: T,
  ...keys: K[]
): Pick<T, K> & {_rest:Array<string>} {


  const pickedErrors = useMemo(()=>{
    // @ts-expect-error(...)
    const pickedErrors : (Pick<T, K> & {_rest:Array<string>}) = { _rest: [] }
    keys.forEach((key) => {
      if (key in errors) {
        // @ts-expect-error(...)
        pickedErrors[key] = errors[key];
      }
    });
    return pickedErrors
  },[errors,keys])

  pickedErrors._rest = useMemo(() => {
    const s: Array<string> = []
    Object.keys(errors).forEach(key => {
      // @ts-expect-error invalid..
      if (pickedErrors[key] == null) {
        s.push(errors[key])
      }
    })
    return s
  }, [errors, keys])

  return pickedErrors
}

